/* eslint-disable react/prop-types */
import {
  CreditCardOutlined,
  DollarOutlined,
  EditOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  MailOutlined,
  PlusOutlined,
  SwapRightOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Spin,
  Tabs,
  TreeSelect,
  Typography,
  message,
} from 'antd';
import { getContenTypePorTipoDePadron, getTipoDePadronPorContenType } from 'api/catalogos';
import { getPredio } from 'api/catastro/predio';
import { getContribuyente, getContribuyenteCaja } from 'api/empresas/contribuyentes';
import { getActuacionesPae } from 'api/pae';
import { getCargosEnEjecucion, postCargoEnEjecucion } from 'api/pae/cargosEnEjecucion';
import {
  baseURI,
  deleteEjecucion,
  getEjecucion,
  patchEjecucion,
  patchSingleEjecucion,
  postEjecucion,
  postEjecucionesBySearch,
} from 'api/pae/ejecuciones';
import { getEstadosDeEjecucion } from 'api/pae/estadosDeEjecucion';
import { getEstatusDeEjecuciones } from 'api/pae/estatusDeEjecuciones';
import { getOrigenesDeCredito } from 'api/pae/origenesDeCredito';
import { getZonasDeDiligenciaArboladas } from 'api/pae/zonasDeDiligencia';
import { getPadronesMap } from 'api/recaudacion/utils';
import Direccion from 'components/Direccion';
import FormSubmitControls from 'components/FormSubmitControls';
import { InputSearchPro } from 'components/InputSearch';
import LadaNumero from 'components/LadaNumero';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import Moment from 'moment';
import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import addressToString from 'utils/address';
import makeMessager from 'utils/complexFormsMessages';
import getFormattedValues, { DATE_FRONTEND_FORMAT, discartNullValues } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import keyGenerator from 'utils/keyGenerator';
import { capitalize } from 'utils/normalizers';
import padronToString, { contribuyenteToString } from 'utils/padronesToString';
import { ActionsNames, getModelPermission, hasActionPermission } from 'utils/permission';
import { getPermissionActionsConfigsPadrones, hasAdvanceSearchPermissions, hasPadronPermission } from 'utils/permission/models';
import { makeGetOnFinish, makeOnChangeTabKey } from 'utils/tabsManagement';
import currencyFormatter from 'utils/toCurrency';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { ACTUACIONES_PAE_ENUM } from 'views/PAE/enums';
import SearchForm from 'views/PAE/ConsultaDeEjecuciones/components/SearchForm';
import { getEstadosDeCarteraPae } from 'api/pae/estatusDeCarteras';
import Previewer from 'components/Previewer';
import { gettersPadronesCajaMap } from 'utils/padrones';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import ModalCartera from './components/ModalCargargarCartera';
import ModalEstatusEjecucion from './components/ModalEstatusEjecucion';
import PadronDescription from '../components/PadronDescription';
import ContribuyenteDescriptor from '../components/ContribuyenteDescriptor';
import TabAdeudo from '../components/TabAdeudo';
import ReadOnlyTabGeneral from '../components/ReadOnlyTabGeneral';

const FormSection = styled(Row).attrs({
  gutter: [10, 10],
})`
`;

const { TabPane } = Tabs;

export const permissionConfig = {
  mainPermission: 'viewcrud_ejecucionpae',
  catalogsModels: [
    'actuacionpae',
    'origendelcreditopae',
    'estatudeejecucionpae',
    'padron',
    'estadoejecucionpae',
    'zonadiligenciapae',
    'cargosenejecucionespae',
  ],
  customActions: [
    {
      title: 'Modificar al siguiente estatus',
      name: 'modificar',
      permissions: ['change_ejecucionpae'],
      action: ActionsNames.change,
    },
    ...getPermissionActionsConfigsPadrones(ActionsNames.add),
    // ...getPermissionActionsConfigsPadrones(ActionsNames.change),
  ],
};

const formatPermission = (_permission) => ({
  ...getModelPermission('ejecucionpae', []),
  ..._permission,
});

const excludeCanceled = (e) => e.estados_globales !== ESTADOS_GLOBALES_MAP.CANCELADO;

const Ejecuciones = ({ permission: _permission }) => {
  const permission = formatPermission(_permission);
  const addressPermission = useMemo(() => getModelPermission('direccion'), []);
  const { estadosGlobales } = useSelector((state) => state.catalogs);
  const { padrones: _padrones } = useSelector((s) => s.catalogs);
  const padrones = _padrones.filter((p) => hasPadronPermission(p.id) && p.id !== 5
    && p?.usado_en_ejecuciones);

  const { padron_principal } = useSelector(({ auth }) => auth.entidad);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mutable, setMutable] = useState(true);
  const [actuaciones, setActuaciones] = useState([]);
  const [origenesDeCredito, setOrigenesDeCredito] = useState([]);
  const [estatusDeEjecucion, setEstatusDeEjecucion] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [tipoDePadron, setTipoDePadron] = useState(padron_principal || 1);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [padronFound, setPadronFound] = useState(null);
  const [dataExterno, setDataExterno] = useState([]);
  const [data, setData] = useState([]);
  const [params, setParams] = useState({});

  const [currentEjecucion, setCurrentEjecucion] = useState(null);

  const [padronFoundBusqueda, setPadronFoundBusqueda] = useState(null);
  const [tipoDePadronBusqueda, setTipoDePadronBusqueda] = useState(padron_principal || 1);
  const [visibleBusquedaContribuyente, setVisibleBusquedaContribuyente] = useState(false);
  const [contribuyenteFound, setContribuyenteFound] = useState(null);
  const [visibleModalEstatusEjecucion, setVisibleModalEstatusEjecucion] = useState(false);
  const [visibleModalCargarCartera, setVisibleModalCargarCartera] = useState(false);
  const [zonasDeDiligencia, setZonasDeDiligencia] = useState([]);
  const [dataHistorial, setDataHistorial] = useState([]);
  const [formAddressNotificaciones, setFormAddressNotificaciones] = useState(null);
  const [estadosDeCarteraPae, setEstadosDeCarteraPae] = useState([]);
  const [base64, setBase64] = useState(null);
  const [visiblePreviewer, setVisiblePreviewer] = useState(false);

  const [formSearch] = Form.useForm();
  const [formGeneral] = Form.useForm();

  const origenDeCreditoSelected = Form.useWatch('origen_del_credito', formGeneral);

  const [formZonaDeDiligencia] = Form.useForm();
  const [formAdeudoHistorico] = Form.useForm();
  const [formCredito] = Form.useForm();

  const formsInstances = [
    formGeneral,
    formZonaDeDiligencia,
    formAdeudoHistorico,
    formCredito,
  ];

  const basicKeys = [
    'general',
    'notificaciones',
    'adeudo_historico',
    'credito_fiscal_determinado',
  ];

  const complexForms = [
    {
      key: 'direccion_de_diligencia_data',
      formInstance: formAddressNotificaciones,
      permission: addressPermission,
    },
  ];

  const displayTitle = (id) => {
    // Validación de entrada
    if (!id || typeof id !== 'number') {
      return 'Padrón';
    }

    // Búsqueda optimizada con early return
    const padron = padrones.find((p) => p?.id === id);

    // Validación del resultado
    if (padron?.descripcion) {
      return `Búsqueda de ${padron.descripcion}`;
    }

    // Fallback con información adicional
    if (padron) {
      return padron.nombre || padron.titulo || 'Padrón sin descripción';
    }

    return 'Padrón no encontrado';
  };

  const fetchData = async () => {
    setLoading(true);
    const res = await postEjecucionesBySearch(params);
    setData(res);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;

    const fetchAll = async () => {
      setLoading(true);
      const [
        _actuaciones,
        _origenesDeCredito,
        _estatusDeEjecuciones,
        _zonasDeDiligenciaArboladas,
        _estadosDeCarteraPae,
      ] = await Promise.all([
        getActuacionesPae(),
        getOrigenesDeCredito(),
        getEstatusDeEjecuciones(),
        getZonasDeDiligenciaArboladas(),
        getEstadosDeCarteraPae(),
      ]);

      if (mounted) {
        setActuaciones(_actuaciones.filter(excludeCanceled));
        setOrigenesDeCredito(_origenesDeCredito.filter((e) => e.padron));
        setEstatusDeEjecucion(_estatusDeEjecuciones.filter(excludeCanceled));
        setZonasDeDiligencia(_zonasDeDiligenciaArboladas.filter(excludeCanceled));
        setEstadosDeCarteraPae(_estadosDeCarteraPae.filter(excludeCanceled));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setMutable(true);
    setSelectedRowKeys([]);
    formGeneral.resetFields();
    formZonaDeDiligencia.resetFields();
    formAdeudoHistorico.resetFields();
    setPadronFound(null);
    setDataExterno([]);
    setPadronFoundBusqueda(null);
    setCurrentTabKey('general');
    setContribuyenteFound(null);
    setCurrentEjecucion(null);
    setDataHistorial([]);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);

      // Validamos los formularios

      await formGeneral.validateFields();
      await formZonaDeDiligencia.validateFields();
      await formAdeudoHistorico.validateFields();

      // Obtenemos los valores de los formularios
      const values = {
        ...formGeneral.getFieldsValue(),
        ...formZonaDeDiligencia.getFieldsValue(),
        ...formAdeudoHistorico.getFieldsValue(),
      };

      // Obtenemos el ID de la ejecución
      const [key] = selectedRowKeys;

      const ejecucionData = {
        ejecucion: values,
        tipo_de_padron: tipoDePadron,
        contribuyente: contribuyenteFound,
        padron: padronFound,
        estatusDeEjecucion: estatusDeEjecucion.find((e) => e.id === values.estatus_de_ejecucion),
      };

      // Guardamos la ejecución
      const saved = await (key ? patchEjecucion(key, ejecucionData) : postEjecucion(ejecucionData));

      if (saved) {
        if (currentEjecucion?.cargos?.length && !key) {
          await Promise.all(currentEjecucion?.cargos.map((cargo) => postCargoEnEjecucion({
            ...cargo,
            ejecucion: saved.id,
          })));
        }

        if (_continue) {
          // eslint-disable-next-line no-use-before-define
          onClickEdit(saved.id);
        } else {
          onCancel();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formsInstances, setCurrentTabKey);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteEjecucion(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const getRecordKey = (record) => (record?.ejecucion_id ?? record?.id);

  const getCurrentStatus = () => {
    const {
      estatus_de_ejecucion_id,
      siguiente_estatus_de_ejecucion_id,
    } = formSearch.getFieldsValue();
    if (estatus_de_ejecucion_id) return estatus_de_ejecucion_id;

    const currentStatus = estatusDeEjecucion
      .find((e) => e.estatus_unico_siguiente_de_ejecucion === siguiente_estatus_de_ejecucion_id);
    return currentStatus?.id ?? null;
  };

  const getNextStatus = () => {
    const {
      estatus_de_ejecucion_id,
      siguiente_estatus_de_ejecucion_id,
    } = formSearch.getFieldsValue();

    if (siguiente_estatus_de_ejecucion_id) return siguiente_estatus_de_ejecucion_id;

    if (estatus_de_ejecucion_id) {
      const currentStatus = estatusDeEjecucion
        .find((e) => e.id === estatus_de_ejecucion_id);
      return currentStatus?.estatus_unico_siguiente_de_ejecucion ?? null;
    }

    return null;
  };

  const handleOnRowClick = (record) => {
    const key = getRecordKey(record);

    if (key === undefined || key === null) return;

    const isSelected = selectedRowKeys.includes(key);

    if (isSelected) {
      setSelectedRowKeys((prev) => prev.filter((k) => k !== key));
    } else {
      setSelectedRowKeys((prev) => [...prev, key]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (keys) => {
      setSelectedRowKeys(keys);
    },
    selections: [
      {
        key: 'select-all-data',
        text: 'Seleccionar todo',
        onSelect: () => {
          const allKeys = (Array.isArray(data) ? data : [])
            .map((r) => getRecordKey(r))
            .filter((k) => k !== undefined && k !== null);
          setSelectedRowKeys(allKeys);
        },
      },
      {
        key: 'clear-selection',
        text: 'Limpiar selección',
        onSelect: () => setSelectedRowKeys([]),
      },
    ],
  };

  const onClickAdd = () => {
    onCancel();
    keyGenerator(data?.results, formGeneral);
    setVisible(true);
  };

  const onClickEdit = async (id) => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys || [id];
      const match = await getEjecucion(key);
      const _cargosEnEjecucion = await getCargosEnEjecucion({ ejecucion: key });
      setCurrentEjecucion({
        ...match,
        cargos: _cargosEnEjecucion,
      });

      formGeneral.setFieldsValue({
        observaciones: match?.observaciones,
      });
      formZonaDeDiligencia.setFieldsValue({
        ...match,
      });
      formAdeudoHistorico.setFieldsValue({
        ...match,
      });
      formCredito.setFieldsValue({
        ...match,
        folio_credito: match?.credito?.id,
        clave_del_credito: match?.credito?.clave,
        numero_cuenta_credito: match?.credito?.numero_de_cuenta_del_credito,
        fecha_hora_registro_credito: match?.credito?.fecha_de_registro_del_credito
          ? Moment(match?.credito?.fecha_de_registro_del_credito).format(DATE_FRONTEND_FORMAT)
          : null,
        estatus_credito: match?.credito?.estado_del_credito?.descripcion,
      });

      const { estatus_de_ejecucion_id } = data.find((e) => e.ejecucion_id === key);
      const matchEstatus = estatusDeEjecucion.find((e) => e.id === estatus_de_ejecucion_id);
      const isMutable = !matchEstatus?.es_estatus_final;

      setMutable(isMutable);

      setVisible(true);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      titleText: 'Folio ID Reporte Moroso',
      dataIndex: 'ejecucion_id',
      key: 'ejecucion_id',
      width: 200,
      align: 'center',
      render: (text) => (
        <Typography.Text strong>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Folio ID Generación',
      dataIndex: 'generacion_id',
      key: 'generacion_id',
      width: 200,
      align: 'center',
      render: (text) => (
        <Typography.Text code>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Fecha de creación',
      dataIndex: 'fecha_de_creacion',
      key: 'fecha_de_creacion',
      width: 200,
      align: 'center',
      render: (text) => (
        <Typography.Text>
          {text?.format(DATE_FRONTEND_FORMAT)}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Origen de Crédito',
      dataIndex: 'origen_descripcion',
      key: 'origen_descripcion',
      width: 400,
      render: (text) => (
        <Typography.Text>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 150,
      align: 'center',
      render: (text) => (
        <Typography.Text code>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Fecha de Estatus',
      dataIndex: 'estado_fecha_de_creacion',
      key: 'estado_fecha_de_creacion',
      width: 180,
      render: (text) => (
        <Typography.Text>
          {text?.format(DATE_FRONTEND_FORMAT)}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Estatus de Reporte Moroso',
      dataIndex: 'estatus_descripcion',
      key: 'estatus_descripcion',
      width: 200,
      ellipsis: true,
      render: (text) => (
        <Typography.Text ellipsis={{ tooltip: text }}>
          {text}
        </Typography.Text>
      ),
    },

    {
      titleText: 'Actuación',
      dataIndex: 'actuacion_descripcion',
      key: 'actuacion_descripcion',
      width: 200,
      ellipsis: true,
      render: (text) => (
        <Typography.Text ellipsis={{ tooltip: text }}>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Fecha de Actuación',
      dataIndex: 'estado_fecha_de_actuacion',
      key: 'estado_fecha_de_actuacion',
      width: 180,
      render: (text) => (
        <Typography.Text>
          {text?.format(DATE_FRONTEND_FORMAT)}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Tipo de Padrón',
      dataIndex: 'tipodepadron_descripcion',
      key: 'tipodepadron_descripcion',
      width: 150,
      render: (text) => (
        <Typography.Text>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Clave del Padrón',
      dataIndex: 'clave_del_padron',
      key: 'clave_del_padron',
      width: 150,
      align: 'center',
      render: (text) => (
        <Typography.Text code>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Clave principal',
      dataIndex: 'clave_principal_del_padron',
      key: 'clave_principal_del_padron',
      width: 200,
      align: 'center',
      render: (text) => (
        <Typography.Text code>
          {text || '-'}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Nombre/Razón Social',
      dataIndex: 'nombres_completos_del_padron',
      key: 'nombres_completos_del_padron',
      width: 400,
      ellipsis: true,
      render: (text) => (
        <Typography.Text ellipsis={{ tooltip: text }}>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Total del Adeudo',
      dataIndex: 'monto_del_adeudo',
      key: 'monto_del_adeudo',
      width: 150,
      align: 'right',
      render: (text) => (
        <Typography.Text strong>
          {text ? currencyFormatter(text) : '-'}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Estatus actual de cartera',
      dataIndex: 'estado_de_cartera_ejecutada',
      key: 'estado_de_cartera_ejecutada',
      width: 300,
      render: (text) => (
        <Typography.Text strong>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Estatus de gastos actuales',
      dataIndex: 'estado_de_gastos_de_ejecucion',
      key: 'estado_de_gastos_de_ejecucion',
      width: 300,
      render: (text) => (
        <Typography.Text strong>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Dirección de Diligencia',
      dataIndex: 'direccion_de_diligencia',
      key: 'direccion_de_diligencia',
      width: 250,
      ellipsis: true,
      render: (_, record) => {
        const direccionString = record?.direccion_de_diligencia
          ? addressToString(record?.direccion_de_diligencia)?.toUpperCase() : '';

        return (
          <Typography.Text ellipsis={{ tooltip: direccionString }}>
            {direccionString || '-'}
          </Typography.Text>
        );
      },
    },
    {
      titleText: 'Colonia',
      dataIndex: 'direccion_de_diligencia',
      key: 'direccion_de_diligencia',
      width: 200,
      ellipsis: true,
      render: (address) => {
        const colonia = (address?.codigo_postal?.d_asenta || '-')?.toUpperCase();

        return (
          <Typography.Text ellipsis={{ tooltip: colonia }}>
            {colonia}
          </Typography.Text>
        );
      },
    },
    {
      titleText: 'Municipio',
      dataIndex: 'direccion_de_diligencia',
      key: 'direccion_de_diligencia',
      width: 200,
      ellipsis: true,
      render: (address) => {
        const municipio = (address?.codigo_postal?.municipio?.nom_mun || '-')?.toUpperCase();

        return (
          <Typography.Text ellipsis={{ tooltip: municipio }}>
            {municipio}
          </Typography.Text>
        );
      },
    },
    {
      titleText: 'Zona de diligencia',
      dataIndex: 'zona_descripcion',
      key: 'zona_descripcion',
      width: 200,
      render: (text) => (
        <Typography.Text ellipsis={{ tooltip: text }}>
          {text}
        </Typography.Text>
      ),
    },
    {
      titleText: 'Clave Crédito Fiscal',
      dataIndex: 'clave_del_credito',
      key: 'clave_del_credito',
      width: 180,
      align: 'center',
      render: (text) => (
        <Typography.Text code>
          {text || '-'}
        </Typography.Text>
      ),
    },
  ];

  const rules = {
    required: [{ required: true }],
  };

  const showMsg = makeMessager(setCurrentTabKey, fetchData);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const formatPadrones = async (_padron) => {
    setLoading(true);
    let padron = _padron;
    if (tipoDePadron === padronesEnum.PREDIO) {
      const predio = await getPredio(_padron.id);
      padron = {
        ..._padron,
        ...predio,
      };
    }
    const nombre_completo = padronToString(padron, tipoDePadron);
    setPadronFound({ ...padron, nombre_completo });
    formGeneral.setFieldsValue({
      padron_id: padron.id,
      direccion_del_padron_id: padron?.direccion_index?.id || padron?.direccion?.id,
    });
    setLoading(false);
  };

  const handleSearchPadron = async () => {
    try {
      setLoading(true);
      const { q_padron } = formGeneral.getFieldsValue();

      if (!q_padron) {
        message.warn('Ingrese al menos un caracter para buscar.');
        setPadronFound([]);
        return;
      }

      const found = await getPadronesMap[tipoDePadron]({ q: q_padron });
      if (found?.length === 1 || found?.results?.length === 1) {
        const [first] = found?.results || found;

        let predio = null;
        if (tipoDePadron === padronesEnum.PREDIO) {
          predio = await getPredio(first.id);
        }

        await formatPadrones({
          ...first,
          ...predio,
        });
      } else if (found?.results?.length > 1) {
        setDataExterno(found);
        setVisibleBusquedaPadrones(true);
        setPadronFound([]);
      } else {
        message.warn('No se encontró ningún padron relacionado.');
        setPadronFound([]);
      }
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const resetAndValidate = () => {
    setPadronFound([]);
    setDataExterno([]);
    setVisibleBusquedaPadrones(false);
    setTipoDePadron(padron_principal || 1);
    formGeneral.resetFields();
  };

  const handleSearchEjecuciones = async (advancedParams = {}) => {
    try {
      const formData = formSearch.getFieldsValue();

      if (formData?.rango_de_fecha_de_ejecucion?.length) {
        const [inicio, fin] = formData.rango_de_fecha_de_ejecucion;

        formData.fecha_de_ejecucion_inicial = inicio;

        formData.fecha_de_ejecucion_final = fin;

        delete formData.rango_de_fecha_de_ejecucion;
      }

      const formattedData = getFormattedValues(discartNullValues({
        ...formData,
        ...advancedParams,
      }));

      if (Object.keys(formattedData).length === 0) {
        message.warn('No se puede buscar ejecuciones sin ningún criterio de búsqueda.');
        return;
      }
      setLoading(true);

      setParams(formattedData);
      const res = await postEjecucionesBySearch(formattedData);
      setData(res);
      setSelectedRowKeys([]);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeOrigenDeCredito = async (value) => {
    try {
      setLoading(true);

      const origen = origenesDeCredito.find((e) => e.id === value);
      const _estatusDeEjecuciones = await getEstatusDeEjecuciones({
        origen_del_credito: value,
        es_estatus_unico_inicial: true,
      });

      formGeneral.setFieldsValue({
        tipo_de_padron: origen?.tipo_de_padron,
        estatus_de_ejecucion: _estatusDeEjecuciones.filter(excludeCanceled)?.[0]?.id,
      });

      let _tipoDePadron = origen?.tipo_de_padron;

      if (!_tipoDePadron) {
        _tipoDePadron = getTipoDePadronPorContenType(origen?.content_type_padron);
      }

      setTipoDePadron(_tipoDePadron);
      setEstatusDeEjecucion(_estatusDeEjecuciones);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentEjecucion !== null && selectedRowKeys.length) {
      const fetchHistorial = async () => {
        const _dataHistorial = await getEstadosDeEjecucion({
          ejecucion: currentEjecucion.id,
        });
        setDataHistorial(_dataHistorial);
      };
      fetchHistorial();
    }
  }, [currentEjecucion]);

  const getOnFinish = makeGetOnFinish(basicKeys, complexForms, currentTabKey, onFinish);
  const _onFinish = getOnFinish();

  const resetAndValidateContribuyente = () => {
    setContribuyenteFound(null);
    formGeneral.setFieldsValue({ contribuyente: null });
  };

  const searchContribuyente = async (_q) => {
    setLoading(true);
    const q = _q || formGeneral.getFieldValue('q');
    if (!q) {
      message.warn('Ingrese al menos un caracter para buscar.');
      setContribuyenteFound(null);
      formGeneral.setFieldsValue({ contribuyente: null });
      return;
    }
    const _contribuyentes = await getContribuyenteCaja({ q });
    if (_contribuyentes.length || _contribuyentes.count) {
      if ((_contribuyentes.length || _contribuyentes.count) === 1) {
        const _contribuyenteFound = _contribuyentes.results?.[0] || _contribuyentes[0];
        setContribuyenteFound(_contribuyenteFound);
        formGeneral.setFieldsValue({ contribuyente: _contribuyenteFound.id });
      } else {
        message.warn('Ingrese una búsqueda más específica');
      }
    } else {
      message.warn('No se encontró el padrón');
    }
    setLoading(false);
  };

  const handleCallbackSearchContribuyente = (padron) => {
    setContribuyenteFound(padron);
    formGeneral.setFieldsValue({ contribuyente: padron.id });
  };

  const handleOnChangeUsarContribuyenteDelPadron = async (value) => {
    if (!value) {
      setContribuyenteFound(null);
      formGeneral.setFieldsValue({ contribuyente: null });
      return;
    }

    if (!padronFound?.id) {
      message.warn('No se ha seleccionado un padrón');
      formGeneral.setFieldsValue({ usar_datos_del_padron: false });
      setLoading(false);
      return;
    }

    if (!padronFound?.contribuyente?.id) {
      message.warn('El padrón no tiene un contribuyente relacionado');
      formGeneral.setFieldsValue({ usar_datos_del_padron: false });
      setLoading(false);
      return;
    }

    setLoading(true);
    const contribuyente = await getContribuyente(padronFound?.contribuyente?.id
      || padronFound?.contribuyente);

    if (!contribuyente) {
      message.warn('No se encontró el contribuyente');
      setLoading(false);
      return;
    }

    setContribuyenteFound(contribuyente);
    formGeneral.setFieldsValue({ contribuyente: contribuyente?.id });
    setLoading(false);
  };

  const handleOnClickCartera = () => {
    const {
      origen_del_credito,
      padron_id,
    } = formGeneral.getFieldsValue();

    if (!origen_del_credito || !padron_id) {
      const missingFields = [];
      if (!origen_del_credito) missingFields.push('Origen del crédito');
      if (!padron_id) missingFields.push('Padrón ');

      message.warning({
        content: (
          <div>
            <p><strong>No se puede cargar la cartera</strong></p>
            <p>Complete los siguientes campos obligatorios:</p>
            <ul style={{ margin: '8px 0', paddingLeft: '20px', textAlign: 'left' }}>
              {missingFields.map((field) => (
                <li key={field}>
                  {field}
                </li>
              ))}
            </ul>
            <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
              Estos datos son necesarios para identificar la cartera a cargar.
            </p>
          </div>
        ),
        key: 'cargar_cartera',
      });
      setCurrentTabKey('general');
      formGeneral.setFields([
        !origen_del_credito && {
          name: 'origen_del_credito',
          errors: ['Falta el origen del crédito'],
        },
      ].filter(Boolean));
      return;
    }

    setVisibleModalCargarCartera(true);
  };

  useEffect(() => {
    if (currentEjecucion?.cargos?.length && !selectedRowKeys.length) {
      const monto_del_adeudo = currentEjecucion.cargos
        .reduce((acc, cargo) => acc + cargo.adeudo_total, 0);

      const fechasVencimiento = currentEjecucion.cargos
        .map((cargo) => cargo?.tipo_de_cargo?.fecha_de_vencimiento)
        .filter((fecha) => fecha)
        .map((fecha) => new Date(fecha));

      let fechaVencimientoMasAntigua = new Date();

      if (fechasVencimiento.length > 0) {
        fechaVencimientoMasAntigua = new Date(Math.min(...fechasVencimiento));
      }

      formAdeudoHistorico.setFieldsValue({
        monto_del_adeudo,
        fecha_de_obligacion_inicial_de_adeudos: new Moment(fechaVencimientoMasAntigua),
      });
    }
  }, [currentEjecucion]);

  const onChangeUsarDatosDelContribuyente = (value) => {
    if (value) {
      formZonaDeDiligencia.setFieldsValue({
        usar_datos_del_padron: false,
      });
      if (!contribuyenteFound?.id) {
        message.warn('No se puede usar los datos del contribuyente porque no se ha seleccionado un contribuyente.');
        setCurrentTabKey('general');
        formGeneral.validateFields(['contribuyente']);
        return;
      }

      if (!contribuyenteFound?.direcciones) {
        message.warn('No se puede usar los datos del contribuyente porque no tiene dirección.');
        formZonaDeDiligencia.setFieldsValue({
          usar_datos_del_contribuyente: false,
        });
      }
    }
  };

  const onChangeUsarDatosDelPadron = (value) => {
    try {
      if (value) {
        formZonaDeDiligencia.setFieldsValue({
          usar_datos_del_contribuyente: false,
        });
        if (!padronFound?.id) {
          message.warn('No se puede usar los datos del padrón porque no se ha seleccionado un padrón.');
          setCurrentTabKey('general');
          formGeneral.validateFields(['padron_id']);
          return;
        }
        if (
          !padronFound?.direccion
          && !padronFound?.direcciones
          && !padronFound?.direccion_index
          && !padronFound?.direccion_notificacion_index
        ) {
          message.warn('No se puede usar los datos del padrón porque no tiene dirección.');
          formZonaDeDiligencia.setFieldsValue({
            usar_datos_del_padron: false,
          });
        }
      }
    } catch (err) {
      onError(err);
    }
  };

  const validarSiguienteEstatus = () => {
    const {
      origen_del_credito_id,
      estatus_de_ejecucion_id,
      siguiente_estatus_de_ejecucion_id,
    } = formSearch.getFieldsValue();

    if (!origen_del_credito_id) return false;
    if (estatus_de_ejecucion_id || siguiente_estatus_de_ejecucion_id) {
      return true;
    }

    return false;
  };

  const handleOnChangeUsarDireccionDelContribuyenteOnEdit = async (value) => {
    if (!value) {
      formZonaDeDiligencia.setFieldsValue({
        usar_datos_del_contribuyente: false,
      });
      return;
    }

    try {
      setLoading(true);
      const contribuyente = await getContribuyente(currentEjecucion?.contribuyente);

      if (!contribuyente) {
        message.warn('No se encontró el contribuyente');
        setLoading(false);
        return;
      }

      if (!contribuyente?.direcciones) {
        message.warn('No se puede usar los datos del contribuyente porque no tiene dirección.');
        formZonaDeDiligencia.setFieldsValue({
          usar_datos_del_contribuyente: false,
        });
      }

      const directionObject = contribuyente?.direcciones;

      await patchSingleEjecucion(currentEjecucion.id, {
        direccion_de_diligencia_data: {
          codigo_postal: directionObject?.codigo_postal?.id,
          estado: directionObject?.codigo_postal?.municipio?.estado?.nombre_de_AGEE,
          municipio: directionObject?.codigo_postal?.municipio?.nom_mun,
          tipo_de_vialidad: directionObject?.tipo_de_vialidad,
          calle_principal: directionObject?.calle_principal,
          numero_exterior: directionObject?.numero_exterior,
          numero_interior: directionObject?.numero_interior,
          tipo_de_vialidad_entre: directionObject?.tipo_de_vialidad_entre,
          entre_calle: directionObject?.entre_calle,
          tipo_de_vialidad_y_calle: directionObject?.tipo_de_vialidad_y_calle,
          y_calle: directionObject?.y_calle,
          descripcion_de_la_ubicacion: directionObject?.descripcion_de_la_ubicacion,
          cp_texto: directionObject?.cp_texto,
          colonia_texto: directionObject?.colonia_texto,
          municipio_texto: directionObject?.municipio_texto,
          estado_texto: directionObject?.estado_texto,
          longitud: directionObject?.longitud,
          latitud: directionObject?.latitud,
        },
      });
      formZonaDeDiligencia.setFieldsValue({
        usar_datos_del_contribuyente: true,
        usar_datos_del_padron: false,
      });
      onClickEdit(currentEjecucion.id);
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOnChangeUsarDireccionDelPadronOnEdit = async (value) => {
    if (!value) {
      formZonaDeDiligencia.setFieldsValue({
        usar_datos_del_padron: false,
      });
      return;
    }
    try {
      setLoading(true);
      const _tipoDePadron = getTipoDePadronPorContenType(currentEjecucion?.content_type_padron);
      const getter = gettersPadronesCajaMap[_tipoDePadron];
      const [padron] = await getter({ id: currentEjecucion?.object_id_padron });

      if (!padron) {
        message.warn('No se encontró el padrón');
        setLoading(false);
        return;
      }

      if (!padron?.direccion
          && !padron?.direcciones
          && !padron?.direccion_index
          && !padron?.direccion_notificacion_index) {
        message.warn('No se puede usar los datos del padrón porque no tiene dirección.');
        formZonaDeDiligencia.setFieldsValue({
          usar_datos_del_padron: false,
        });
      }

      const directionObject = padron?.direccion_index
        || padron?.direcciones
        || padron?.direccion_notificacion_index;

      await patchSingleEjecucion(currentEjecucion.id, {
        direccion_de_diligencia_data: {
          codigo_postal: directionObject?.codigo_postal?.id,
          estado: directionObject?.codigo_postal?.municipio?.estado?.nombre_de_AGEE,
          municipio: directionObject?.codigo_postal?.municipio?.nom_mun,
          tipo_de_vialidad: directionObject?.tipo_de_vialidad,
          calle_principal: directionObject?.calle_principal,
          numero_exterior: directionObject?.numero_exterior,
          numero_interior: directionObject?.numero_interior,
          tipo_de_vialidad_entre: directionObject?.tipo_de_vialidad_entre,
          entre_calle: directionObject?.entre_calle,
          tipo_de_vialidad_y_calle: directionObject?.tipo_de_vialidad_y_calle,
          y_calle: directionObject?.y_calle,
          descripcion_de_la_ubicacion: directionObject?.descripcion_de_la_ubicacion,
          cp_texto: directionObject?.cp_texto,
          colonia_texto: directionObject?.colonia_texto,
          municipio_texto: directionObject?.municipio_texto,
          estado_texto: directionObject?.estado_texto,
          longitud: directionObject?.longitud,
          latitud: directionObject?.latitud,
        },
      });
      formZonaDeDiligencia.setFieldsValue({
        usar_datos_del_padron: true,
        usar_datos_del_contribuyente: false,
      });
      onClickEdit(currentEjecucion.id);
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin
        tip="Cargando..."
        spinning={loading}
      >
        {!visible && (
          <>
            <SearchForm
              handleSearchData={handleSearchEjecuciones}
              setData={setData}
              setParams={setParams}
              loading={loading}
              origenesDeCredito={origenesDeCredito}
              tipoDePadron={tipoDePadronBusqueda}
              setTipoDePadron={setTipoDePadronBusqueda}
              formSearch={formSearch}
              padronFound={padronFoundBusqueda}
              setPadronFound={setPadronFoundBusqueda}
              estadosDeCarteraPae={estadosDeCarteraPae}
              setSelectedRowKeys={setSelectedRowKeys}
            />
            <Typography.Title level={4}>
              Seleccionados
              {' '}
              {selectedRowKeys.length}
            </Typography.Title>
            <Table
              cols={columns}
              data={data}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              allowSearch={false}
              customActions={[
                {
                  icon: <PlusOutlined />,
                  text: 'Agregar',
                  onClick: onClickAdd,
                  hasPermission: permission?.add,
                  disabledBySelection: false,
                },
                {
                  icon: <EditOutlined />,
                  text: 'Editar',
                  onClick: onClickEdit,
                  hasPermission: permission?.change,
                  disabled: selectedRowKeys.length > 1,
                },
                {
                  icon: <SwapRightOutlined />,
                  text: 'Modificar a sig. estatus',
                  onClick: () => {
                    const [key] = selectedRowKeys;
                    const { estatus_de_ejecucion_id } = data.find((e) => e.ejecucion_id === key);
                    const match = estatusDeEjecucion.find((e) => e.id === estatus_de_ejecucion_id);
                    if (match?.es_estatus_final) {
                      message.warn('No se puede modificar a un estatus si ya se finalizo el reporte moroso');
                      return;
                    }

                    setVisibleModalEstatusEjecucion(true);
                  },
                  disabled: !selectedRowKeys.length || !validarSiguienteEstatus(),
                  hasPermission: hasActionPermission('ejecucionpae', ActionsNames.change),
                },
              ]}
              rowKey="ejecucion_id"
              permission={permission}
              hasAllViewPermission={permission?.hasAllViewPermission}
              allowColumnSelector={false}
            />
          </>
        )}
        {visible && (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Reporte Moroso`}
            extra={(
              <FormSubmitControls
                onFinish={_onFinish}
                onCancel={onCancel}
                loading={loading}
                mutable={mutable}
                permission={permission}
                selectedRowKeys={selectedRowKeys}
                baseURI={baseURI}
                callback={(id) => {
                  const [key] = selectedRowKeys;
                  const normalized = data.map((e) => {
                    if (e.id === key) {
                      const match = estadosGlobales.find((eg) => eg.id === id);
                      formGeneral.setFieldsValue({ estados_globales: match.id });
                      setMutable(true);
                      return { ...e, estados_globales: id };
                    }
                    return e;
                  });
                  setData(normalized);
                }}
              />
            )}
            bordered={false}
          >
            <Tabs
              onChange={mutable ? onChangeTabKey : setCurrentTabKey}
              activeKey={currentTabKey}
              type="card"
            >
              <TabPane
                tab={(
                  <>
                    <FileTextOutlined />
                    Datos del Reporte Moroso
                  </>
                )}
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  name="general"
                  form={formGeneral}
                  onFinish={(_, _continue) => _onFinish(_continue)}
                  scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                  }}
                  initialValues={{
                    estados_globales: 1,
                    tipo_de_padron: padron_principal,
                    usar_contribuyente_del_padron: false,
                    fecha_de_ejecucion: new Moment(),
                    actuacion: ACTUACIONES_PAE_ENUM.GENERADO,
                  }}
                >
                  {!!selectedRowKeys.length && (
                    <ReadOnlyTabGeneral
                      ejecucion={currentEjecucion}
                      origenesDeCredito={origenesDeCredito}
                      estatusDeEjecuciones={estatusDeEjecucion}
                      setEjecucion={setCurrentEjecucion}
                      mutable={mutable}
                      estadosDeEjecucion={dataHistorial}
                    />
                  )}

                  {!selectedRowKeys.length && (
                    <>
                      <FormSection>
                        {!!selectedRowKeys.length && (
                        <Col xs={24} md={4}>
                          <Form.Item
                            name="id"
                            label="ID"
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        )}
                        {!!selectedRowKeys.length && (
                        <Col xs={24} md={4}>
                          <Form.Item
                            name="folio"
                            label="Folio"
                          >
                            <Input
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        )}
                        <Col xs={24} md={4}>
                          <Form.Item
                            name="origen_del_credito"
                            label="Origen de Crédito"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={origenesDeCredito}
                              allowClear
                              disabled={!mutable || selectedRowKeys.length}
                              onChange={onChangeOrigenDeCredito}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={4}>
                          <Form.Item
                            name="fecha_de_ejecucion"
                            label="Fecha y hora"
                          >
                            <DatePicker
                              showTime
                              allowClear
                              format="DD/MM/YYYY HH:mm"
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={4}>
                          <Form.Item
                            name="estatus_de_ejecucion"
                            label="Estado de Reporte Moroso"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={estatusDeEjecucion.filter((e) => e.orden_de_uso !== 0)}
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={4}>
                          <Form.Item
                            name="actuacion"
                            label="Actuación"
                          >
                            <Select
                              dataSource={actuaciones}
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={16}>
                          <Form.Item
                            name="observaciones"
                            label="Observaciones de reporte moroso"
                            normalize={(value) => capitalize(value)}
                          >
                            <Input.TextArea
                              allowClear
                              disabled={!mutable}
                              autoSize={{ minRows: 3, maxRows: 6 }}
                              maxLength={500}
                            />
                          </Form.Item>
                        </Col>
                      </FormSection>
                      {!!origenDeCreditoSelected && (
                      <FormSection>
                        <Col span={24}>
                          <Typography.Title level={4}>Padrón</Typography.Title>
                        </Col>
                        <InputSearchPro
                          rules={rules.required}
                          tooltip="Tipo de padrón definido por el origen de credito"
                          prefix={{
                            rules: rules.required,
                            style: { width: '100%' },
                            name: 'tipo_de_padron',
                            label: 'padron',
                            disabled: true,
                            dataSource: padrones,
                            onChange: (e) => setTipoDePadron(e),
                          }}
                          name="q_padron"
                          disabled={selectedRowKeys.length}
                          onClickAdvanced={hasAdvanceSearchPermissions(tipoDePadron)
                            ? () => setVisibleBusquedaPadrones(true) : null}
                          label={displayTitle(tipoDePadron)}
                          inputProps={{
                            onPressEnter: () => handleSearchPadron(),
                          }}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          resultProps={{
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                            name: 'padron_id',
                            render: (value) => padronToString(value, tipoDePadron),
                            label: displayTitle(tipoDePadron),
                            dataSource: padronFound,
                            onClear: resetAndValidate,
                          }}
                        />
                      </FormSection>
                      )}
                      <PadronDescription
                        padron={padronFound}
                        tipoDePadron={tipoDePadron}
                        setObservaciones={setPadronFound}
                      />
                      <br />
                      <FormSection>
                        <Col span={24}>
                          <Row justify="space-between">
                            <Typography.Title level={4}>Contribuyente</Typography.Title>
                            <Col xs={24} md={8}>
                              <Form.Item
                                name="usar_contribuyente_del_padron"
                                label="Usar contribuyente del padrón"
                              >
                                <Select
                                  trueFalse
                                  disabled={selectedRowKeys.length
                                    || !origenDeCreditoSelected
                                    || !padronFound}
                                  onChange={handleOnChangeUsarContribuyenteDelPadron}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <InputSearchPro
                          label="Búsqueda Contribuyente"
                          name="q"
                          onClickAdvanced={() => setVisibleBusquedaContribuyente(true)}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          inputProps={{
                            onPressEnter: () => searchContribuyente(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidateContribuyente();
                              }
                            },
                          }}
                          resultProps={{
                            name: 'contribuyente',
                            label: 'Contribuyente',
                            rules: rules.required,
                            dataSource: contribuyenteFound,
                            render: (padron) => contribuyenteToString(padron),
                            keyLabelRender: false,
                            onClear: resetAndValidateContribuyente,
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                          }}
                          disabled={!mutable || !origenDeCreditoSelected}
                        />
                      </FormSection>
                      <ContribuyenteDescriptor
                        contribuyente={contribuyenteFound}
                        setObservaciones={setContribuyenteFound}
                      />
                      <br />
                      <Row gutter={10}>
                        <Col xs={24} md={8}>
                          <Form.Item
                            name="estados_globales"
                            label="Estado"
                            hasFeedback
                            hidden
                          >
                            <Select
                              dataSource={estadosGlobales}
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </>
                  )}
                </Form>
              </TabPane>
              <TabPane
                tab={(
                  <>
                    <MailOutlined />
                    Diligencia de notificaciones
                  </>
                )}
                key="notificaciones"
              >
                <Form
                  layout="vertical"
                  name="notificaciones"
                  form={formZonaDeDiligencia}
                  onFinish={(_, _continue) => _onFinish(_continue)}
                  scrollToFirstError
                  forceRender
                  initialValues={{
                    usar_datos_del_padron: false,
                    usar_datos_del_contribuyente: false,
                  }}
                >
                  <Row gutter={[10, 10]} justify="end">
                    {/* Segunda fila: Zona de Diligencia */}
                    <Col xs={24} md={8}>
                      <Form.Item
                        name="zona_de_diligencia"
                        label="Zona de Diligencia"
                      >
                        <TreeSelect
                          treeData={zonasDeDiligencia}
                          treeDataSimpleMode
                          treeDefaultExpandAll
                          showSearch
                          disabled={!mutable}
                          treeNodeFilterProp="label"
                          style={{ width: '100%' }}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          filterTreeNode={(input, treeNode) => {
                            if (!input || input.trim() === '') {
                              return treeNode.props.selectable;
                            }

                            const nodeText = treeNode.props.descripcion
                              || treeNode.props.label || '';

                            const matchesSearch = nodeText?.toLowerCase()
                              .includes(input.toLowerCase());

                            return matchesSearch
                              && treeNode.props.selectable;
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item
                        name="usar_datos_del_padron"
                        label="Usar datos del padrón"
                      >
                        <Select
                          trueFalse
                          disabled={!mutable}
                          onChange={selectedRowKeys.length
                            ? handleOnChangeUsarDireccionDelPadronOnEdit
                            : onChangeUsarDatosDelPadron}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item
                        name="usar_datos_del_contribuyente"
                        label="Usar datos del contribuyente"
                      >
                        <Select
                          trueFalse
                          disabled={!mutable}
                          onChange={selectedRowKeys.length
                            ? handleOnChangeUsarDireccionDelContribuyenteOnEdit
                            : onChangeUsarDatosDelContribuyente}
                        />
                      </Form.Item>
                    </Col>

                  </Row>

                  <Row gutter={[10, 10]}>
                    <Divider orientation="left">Información de Contacto</Divider>
                    <LadaNumero
                      disabled={!mutable}
                      names={{
                        lada: 'lada_de_telefono',
                        numero_de_telefono: 'telefono_de_diligencia',
                      }}
                      label="Teléfono de Diligencia"
                      breakPoints={{
                        xs: 24,
                        sm: 24,
                        md: 8,
                        lg: 8,
                        xl: 8,
                        xxl: 8,
                      }}
                    />
                    <LadaNumero
                      disabled={!mutable}
                      names={{
                        lada: 'lada_celular_de_diligencia',
                        numero_de_telefono: 'celular_de_diligencia',
                      }}
                      label="Celular de Diligencia"
                      breakPoints={{
                        xs: 24,
                        sm: 24,
                        md: 8,
                        lg: 8,
                        xl: 8,
                        xxl: 8,
                      }}
                    />
                    <Col xs={24} md={12}>
                      <Form.Item
                        name="correo_electronico_de_diligencia"
                        label="Correo electrónico de diligencia"
                        rules={[
                          {
                            type: 'email',
                            message: 'El correo electrónico no es válido',
                          },
                        ]}
                      >
                        <Input allowClear disabled={!mutable} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </TabPane>
              {addressPermission.view && (
                <TabPane
                  tab={(
                    <>
                      <EnvironmentOutlined />
                      Dirección de Diligencia
                    </>
                  )}
                  key="direccion_de_diligencia_data"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <Direccion
                    setFormAddress={setFormAddressNotificaciones}
                    currentURI={baseURI}
                    parentID={selectedRowKeys[0]}
                    setLoading={setLoading}
                    setCurrentTabKey={setCurrentTabKey}
                    addressPropName="direccion_de_diligencia"
                    callback={(values, _continue) => {
                      if (!_continue) {
                        onCancel();
                      } else {
                        const [key] = selectedRowKeys;
                        const normalized = data.map((e) => (e.id === key
                          ? ({ ...e, direccion_de_diligencia_data: values?.id }) : e));
                        setData(normalized);
                      }
                    }}
                    permission={addressPermission}
                    mutable={mutable}
                  />
                </TabPane>
              )}
              <TabPane
                tab={(
                  <>
                    <DollarOutlined />
                    Adeudo histórico
                  </>
                )}
                key="adeudo_historico"
                forceRender
              >
                <TabAdeudo
                  form={formAdeudoHistorico}
                  _onFinish={(_, _continue) => _onFinish(_continue)}
                  loading={loading}
                  selectedRowKeys={selectedRowKeys}
                  handleOnClickCartera={handleOnClickCartera}
                  currentEjecucion={currentEjecucion}
                  mutable={mutable}
                />
              </TabPane>
              <TabPane
                tab={(
                  <>
                    <CreditCardOutlined />
                    Credito Fiscal determinado
                  </>
                )}
                key="credito_fiscal_determinado"
                forceRender
              >
                <Form
                  layout="vertical"
                  name="credito_fiscal_determinado"
                  form={formCredito}
                  onFinish={(_, _continue) => _onFinish(_continue)}
                  scrollToFirstError
                >
                  <br />
                  <FormSection justify="end">
                    <Col xs={24} md={6}>
                      <Form.Item
                        name="folio_credito"
                        label="Folio"
                      >
                        <Input
                          allowClear
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                      <Form.Item
                        name="clave_del_credito"
                        label="Clave"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                      <Form.Item
                        name="numero_cuenta_credito"
                        label="Número de cuenta del crédito"
                      >
                        <Input
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                      <Form.Item
                        name="fecha_hora_registro_credito"
                        label="Fecha y hora de registro"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                      <Form.Item
                        name="estatus_credito"
                        label="Estatus del crédito"
                      >
                        <Select
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Divider orientation="left">
                        Estatus Historicos de reporte moroso
                      </Divider>

                      <Table
                        cols={[
                          {
                            titleText: 'ID',
                            dataIndex: 'id',
                            key: 'id',
                            width: 80,
                            align: 'center',
                            render: (text) => (
                              <Typography.Text strong>
                                {text}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Fecha',
                            dataIndex: 'fecha_de_creacion',
                            key: 'fecha_de_creacion',
                            width: 200,
                            render: (text) => (
                              <Typography.Text>
                                {text?.format('DD/MM/YYYY HH:mm') || '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Estatus de Reporte Moroso',
                            dataIndex: 'estatus_de_ejecucion',
                            key: 'estatus_de_ejecucion',
                            width: 400,
                            ellipsis: true,
                            render: (value) => {
                              const status = estatusDeEjecucion.find((e) => e.id === value);
                              return (
                                <Typography.Text ellipsis={{ tooltip: status?.descripcion }}>
                                  {status?.descripcion || '-'}
                                </Typography.Text>
                              );
                            },
                          },
                          {
                            titleText: 'Fecha de Actuación',
                            dataIndex: 'fecha_de_actuacion',
                            key: 'fecha_de_actuacion',
                            width: 200,
                            render: (text) => (
                              <Typography.Text>
                                {text?.format(DATE_FRONTEND_FORMAT) || '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Zona de Diligencia',
                            dataIndex: 'zona_de_diligencia',
                            key: 'zona_de_diligencia',
                            width: 200,
                            ellipsis: true,
                            render: (text) => (
                              <Typography.Text ellipsis={{ tooltip: text }}>
                                {text || '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Recibo',
                            dataIndex: 'recibo',
                            key: 'recibo',
                            width: 180,
                            align: 'center',
                            render: (recibo) => (
                              <Typography.Text code>
                                {recibo?.folio || '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Importe del Recibo',
                            dataIndex: 'recibo',
                            key: 'recibo',
                            width: 180,
                            align: 'right',
                            render: (recibo) => (
                              <Typography.Text>
                                {recibo?.importe_total
                                  ? currencyFormatter(recibo?.importe_total) : '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Recibo Cancelado',
                            dataIndex: 'recibo_cancelado',
                            key: 'recibo_cancelado',
                            width: 150,
                            align: 'center',
                            render: (text) => (
                              <Typography.Text type={text ? 'danger' : 'success'}>
                                {text ? 'Sí' : 'No'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Clave de Crédito',
                            dataIndex: 'clave_de_credito',
                            key: 'clave_de_credito',
                            width: 140,
                            align: 'center',
                            render: (text) => (
                              <Typography.Text code>
                                {text || '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Fecha de Vencimiento',
                            dataIndex: 'fecha_de_vencimiento_del_estado',
                            key: 'fecha_de_vencimiento_del_estado',
                            width: 240,
                            render: (text) => (
                              <Typography.Text>
                                {text?.format(DATE_FRONTEND_FORMAT) || '-'}
                              </Typography.Text>
                            ),
                          },
                          {
                            titleText: 'Notas de Errores',
                            dataIndex: 'nota_de_errores_del_estado',
                            key: 'nota_de_errores_del_estado',
                            width: 700,
                            render: (text) => (
                              <Typography.Text className={text ? 'danger' : ''}>
                                {text || '-'}
                              </Typography.Text>
                            ),
                          },
                        ]}
                        data={dataHistorial}
                        noControls
                        allowSearch={false}
                        allowSort={false}
                        allowColumnSelector={false}
                      />
                    </Col>
                  </FormSection>
                </Form>
              </TabPane>
            </Tabs>

          </Card>
        )}

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => {
            setVisibleAlert(false);
            onCancel();
          }}
          visible={visibleAlert}
          content={` el reporte moroso ${formGeneral.getFieldValue('descripcion')}`}
          loading={loading}
        />

        <BusquedaAvanzadaPadrones
          visible={visibleBusquedaPadrones}
          setVisible={setVisibleBusquedaPadrones}
          callback={formatPadrones}
          dataExterno={dataExterno}
          setDataExterno={setDataExterno}
          tipoDePadron={tipoDePadron}
        />
        <BusquedaAvanzadaPadrones
          visible={visibleBusquedaContribuyente}
          setVisible={setVisibleBusquedaContribuyente}
          callback={handleCallbackSearchContribuyente}
          tipoDePadron={padronesEnum.CONTRIBUYENTE}
        />
        <ModalEstatusEjecucion
          visible={visibleModalEstatusEjecucion}
          setVisible={setVisibleModalEstatusEjecucion}
          estatusDeEjecucion={estatusDeEjecucion}
          nextStatus={getNextStatus()}
          currentStatus={getCurrentStatus()}
          ejecuciones={selectedRowKeys}
          callback={async (result) => {
            if (result.success) {
              await handleSearchEjecuciones();
              message.success(result.message || 'Estatus actualizado correctamente.');
              setVisibleModalEstatusEjecucion(false);
            }
          }}
        />
        <Previewer
          base64={base64}
          visible={visiblePreviewer}
          setVisible={(value) => {
            setVisiblePreviewer(value);
            setBase64(null);
          }}
        />
        <ModalCartera
          visible={visibleModalCargarCartera}
          onCancel={() => setVisibleModalCargarCartera(false)}
          idEjecucion={selectedRowKeys[0]}
          objectId={formGeneral.getFieldValue('padron_id')}
          contenttype={getContenTypePorTipoDePadron(tipoDePadron)}
          sistema={origenesDeCredito.find((e) => e.id === formGeneral
            .getFieldValue('origen_del_credito'))?.sistema}
          setEjecucion={setCurrentEjecucion}
          disabled={!mutable}
        />
      </Spin>
    </Row>
  );
};

export default Ejecuciones;
